<template>
  <div class="text-item-wrap">
    <div class="text-label-wrap">
      <span class="text-label">
        {{ label }}
        <div v-if="beforeTooltip" class="tooltip-box">
          <lego-icon :iconType="'line'" :icon="'new_information'" :size="16" />
          <lego-tooltip :right="true" :mouseOver="true" class="tooltip-wrap long">
            <slot name="tooltip">
              <div>{{ $t('page.performance.logging') }}</div>
            </slot>
          </lego-tooltip>
        </div>
        <div v-if="blockStorage" class="product-blockstorage">(Dedicated/Shared)</div>
      </span>
    </div>
    <TextBox
      :value="value"
      :isHtml="isHtml"
      :tooltip="tooltip"
      :withoutPointer="withoutPointer"
      :textLineClamp="textLineClamp"
      :icon="icon"
      :widthIcon="widthIcon"
    />
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin.js';
import TextBox from '@/containers/popup/components/TextBoxV2.vue';

export default {
  name: 'TextItem',
  mixins: [i18nMixin],
  components: {
    TextBox
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    blockStorage: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    beforeTooltip: {
      type: Boolean,
      default: false
    },
    withoutPointer: {
      type: Boolean,
      default: false
    },
    textLineClamp: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    widthIcon: {
      type: String,
      default: '28'
    },
    isHtml: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.text-item-wrap {
  // position: relative;
  font-family: $lego__font-family !important;

  .text-label-wrap {
    width: 240px;
    height: 16px;

    .text-label {
      display: inline-block;
      width: 90%;
      font-family: $lego__font-family;
      font-size: 14px;
      line-height: 16px;
      color: #2e3138;
      font-weight: 700;
      gap: 8px;
    }
  }
  .product-blockstorage {
    display: inline-block;
    color: #737a8c;
    font-weight: 400 !important;
    font-size: 12px !important;
  }
}
.tooltip-box {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;

  ::v-deep .lego-icon {
    position: absolute;
    top: 2px;
    left: 2px;
    color: rgba(31, 37, 51, 1);
  }
}
</style>
